import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'consultationsFilter', namespaced: true })
export default class ConsultationsFilter extends FilterModule {
    constructor(module: ConsultationsFilter) {
        super(module);
    }
}
